<script>
import { ready as pyReady, evaluate as pyEval } from './pyeval.mjs';
import { BarLoader } from 'svelte-loading-spinners'

export async function evaluate(text) {
    systemError = null;
    stdout = [];
    figures = [];
    result = null;
    try {
        const res = await pyEval(text, (s) => stdout = [...stdout, s]);
        ({ result, figures=[], error } = res);
        noOutput = (result == null && error == null && figures.length == 0 && stdout.length == 0);    
    } catch (err) {
        console.log("systemError");
        systemError = err.message;
    }
};
export let ready = false;
$: ready = $pyReady;

let result = null;
let stdout = [];
let figures = [];
let error = null;
let noOutput = false;
let systemError = null;


</script>

{#if systemError }
<div class="systemError">
    <h3>System error</h3>
    <p>Please contact the lecturer. And try reloading the page.</p>
    <hr>
    <pre>{systemError}</pre>
</div>
{:else if !ready & stdout.length == 0 }
<div class="loading">
    <BarLoader size="60" color="#FF3E00" unit="px" duration="1s" />
</div>
{:else}
<div class="output">
    {#each stdout as s}
    <pre class="stdout">
    {s}
    </pre>
    {/each}
    {#each figures as fig }
    <div class="figure">
    {@html fig }
    </div>
    {/each}
    {#if error != null}
    <pre class="error">
    {error}
    </pre>
    {/if}
    {#if result != null}
        {#if result.html != null}
        <div class="html">{@html result.html}</div>
        {:else}
        <pre>{result}</pre>
        {/if}
    {/if}
    {#if noOutput}
    <div>(No output)</div>
    {/if}
</div>
{/if}

<style>
.output {
    width: 100%;
    height: 100%;
    overflow: auto;
    font-family: var(--font-mono);
    font-size: .9rem;
}
.loading {
    width: 100%; height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
pre.stdout {
    font-size: 90%;
    font-style: italic;
    margin-bottom: 0em;
    margin-top: 0em;
}
pre.error {
    color: red;
}
.systemError {
    background-color: rgb(204, 21, 204);
    color: white;
    border: solid black 2pt;
    margin: 1.5rem;
    padding: 0.5rem;
}
.systemError h3 {
    color: white;
    font-weight: bold;
}
.systemError pre {
    font-size: 62.5%;
}
.output .html :global(table.dataframe) {
    border-collapse: collapse;
    border-spacing: 0;
    margin-top: 1em;
    margin-bottom: 0.5em;
    font-family: var(--font);
}
.output .html :global(.dataframe thead) {
    border-bottom: solid black 1pt;
}
.output .html :global(.dataframe th) {
    background-color: rgb(228, 243, 255);
    padding: 0.2em 0.5em;
}

</style>